module.exports = __webpack_public_path__ + "img/tanning.906639d0.svg";